import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';

import { buildDashboardThemeVars } from '../../shared/dashboard-widget-theme';
@Component({
	selector: 'app-customer-open-quotes',
	templateUrl: './customer-quotes.component.html',
	styleUrls: ['./customer-quotes.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 180deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class CustomerOpenQuotesComponent implements OnInit {

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('cw', 'primary');
	}
	@Input() flip = 'inactive';
	@Output() viewData = new EventEmitter < any > ();
	viewing: any = false;

	data: any = false;
	title = 'Open Quotes';

	constructor(private ordersService: OrdersService, private customerService: CustomerService) {}

	/** Open-quote API puts the merged SQL row on `details`; top-level display fields may be missing — read from there. */
	private normalizeOpenQuoteRow(row: any): any {
		if (!row || typeof row !== 'object') {
			return row;
		}
		const d = row.details;
		if (!d || typeof d !== 'object') {
			return row;
		}
		const salesperson = String(row.salesperson_name || d.quote_salesperson_name || d.salesmanname || '').trim();
		const enteredName = String(row.enteredby_display || d.quote_enteredby_name || row.enteredby_name || '').trim();
		const enteredRaw = String(d.quote_enteredby_userid || d.enteredby || row.enteredby || '').trim();
		const takenName = String(row.takenby_name || d.quote_takenby_name || '').trim();
		const takenRaw = String(d.quote_takenby_userid || d.takenby || row.takenby || '').trim();
		let enteredLine = String(row.enteredby_line || '').replace(/^\s*Entered\s*By\s*:\s*/i, '').trim();
		if (!enteredLine) {
			if (enteredName) {
				enteredLine = enteredName;
			} else if (enteredRaw) {
				enteredLine = enteredRaw;
			} else if (takenName) {
				enteredLine = takenName;
			} else if (takenRaw) {
				enteredLine = takenRaw;
			}
		}
		return {
			...row,
			salesperson_name: salesperson || row.salesperson_name,
			enteredby_line: enteredLine || row.enteredby_line,
			enteredby_display: enteredName || enteredRaw || row.enteredby_display,
		};
	}

	ngOnInit(): void {
		this.ordersService.getOpenQuotes().subscribe((results: any) => {
			const raw = Array.isArray(results) ? results : (results && Array.isArray(results.data) ? results.data : []);
			this.data = raw.map((r: any) => this.normalizeOpenQuoteRow(r));
		});
	}

	toggleFlip(data: any, title: string) {

		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title
			const dashboard_data = { data: data, title: this.title }
			this.viewData.emit(dashboard_data);
		} else {
			this.viewData.emit(false);
		}
	}
}
